import * as React from "react";
import type { SVGProps } from "react";
const SvgShield02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.342 3.07a3 3 0 0 0-2.684 0L4.8 6v8.028c0 2.172 2.562 4.643 7.2 7.572 4.638-2.929 7.2-4.8 7.2-7.572V6z"
    />
  </svg>
);
export default SvgShield02;
